import React, { useState } from 'react';
import styled from 'styled-components';
import useTypeListConvergence from "../Hooks/ConvergenceHooks/useTypeListConvergence";
import useAddConvergence from '../Hooks/ConvergenceHooks/useAddConvergence';


function ConvergenceAdd({ onClose }) {
  const [formData, setFormData] = useState({
    type: "",
    program: "",
    indicator: "",
    status2024: "",
    target2025: "",
    total: "",
    statusToDate: "",
    remarks: ""
  });

function normalizeConvergenceData(rawArray) {
  const result = {};
  if (!Array.isArray(rawArray)) {
    console.warn("normalizeConvergenceData expected an array but got:", rawArray);
    return result;
  }

  rawArray.forEach(item => {
    const typeKey = item.type ? item.type.trim() : "";
    if (typeKey) {
      const programsArray = item.programs
        ? item.programs.split(',').map(p => p.trim()).filter(Boolean)
        : [];
      result[typeKey] = programsArray;
    }
  });

  console.log("Normalized data:", result);
  return result;
}


const { groupedConvergenceData, loading, error } = useTypeListConvergence();

const types = Object.keys(groupedConvergenceData);
const selectedData = groupedConvergenceData[formData.type] || { programs: [], indicators: [] };
const programs = selectedData.programs;
const indicators = selectedData.indicators;
const { addConvergence, loading: submitting, error: submitError, success } = useAddConvergence();
const [isHovering, setIsHovering] = useState(false);
 
 const handleChange = (field, value) => {
  if (value === "__add_new__") {
    setAddingNew(prev => ({ ...prev, [field]: true }));
    setFormData(prev => ({ ...prev, [field]: "" }));
  } else if (addingNew[field]) {
    // Don't toggle addingNew off while typing
    setFormData(prev => ({ ...prev, [field]: value }));
  } else {
    setAddingNew(prev => ({ ...prev, [field]: false }));
    setFormData(prev => ({
      ...prev,
      [field]: value,
      ...(field === 'type' ? { program: "", indicator: "" } : {}),
    }));
  }
};




    const [addingNew, setAddingNew] = useState({
      type: false,
      program: false,
      indicator: false,
    });



 const handleSubmit = async () => {
  const payload = {
    type: formData.type,
    program: formData.program,
    indicator: formData.indicator,
    status_2024: formData.status2024,
    target_2025: formData.target2025,
    total: formData.total,
    status_date: formData.statusToDate,
    remarks: formData.remarks
  };

  try {
    const result = await addConvergence(payload);
    console.log('Submitted successfully:', result);

    // ✅ Clear form state
    setFormData({
      type: "",
      program: "",
      indicator: "",
      status2024: "",
      target2025: "",
      total: "",
      statusToDate: "",
      remarks: ""
    });
    setAddingNew({
      type: false,
      program: false,
      indicator: false
    });

    onClose(); // Close modal (or remove this if you want to stay open after submit)
  } catch (e) {
    console.error('Submit failed:', e);
  }
};




  return (
    <Container>
      <FormContainer>
        <Title>
          <span>Add Program Entry</span>
          <CloseButton
            onClick={onClose}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            style={{ color: isHovering ? "#000" : "#666" }}
          >
            ×
          </CloseButton>
        </Title>

          {error && <p style={{ color: 'red' }}>Error loading data: {error}</p>}
        {loading && <p>Loading...</p>}

        {submitting && <p>Submitting data...</p>}
        {submitError && <p style={{ color: 'red' }}>Error submitting: {submitError}</p>}
        {success && <p style={{ color: 'green' }}>Successfully submitted!</p>}

        <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          <CardSection>

                <FieldGroup>
          <Label>Type</Label>
          {!addingNew.type ? (
            <select
              value={formData.type}
              onChange={(e) => handleChange("type", e.target.value)}
              disabled={loading}
            >
              <option value="">Select type</option>
              {types.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
              <option value="__add_new__">➕ Add new type</option>
            </select>
          ) : (
            <Input
              type="text"
              placeholder="Enter new type"
              value={formData.type}
              onChange={(e) => handleChange("type", e.target.value)}
               onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); // Prevent form submission
              }
            }}
            />
          )}
        </FieldGroup>




       <FieldGroup>
        <Label>Under Program Name</Label>
        {!addingNew.program ? (
          <select
            value={formData.program}
            onChange={(e) => handleChange("program", e.target.value)}
            onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
            disabled={!formData.type || loading}
          >
            <option value="">Select under program</option>
            {programs.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
            <option value="__add_new__">➕ Add new program</option>
          </select>
        ) : (
          <Input
            type="text"
            placeholder="Enter new program"
            value={formData.program}
            onChange={(e) => handleChange("program", e.target.value)}
          />
        )}
      </FieldGroup>




       <FieldGroup>
      <Label>Indicator</Label>
      {!addingNew.indicator ? (
        <select
          value={formData.indicator}
          onChange={(e) => handleChange("indicator", e.target.value)}
          disabled={!formData.type || loading}
        >
          <option value="">Select indicator</option>
          {indicators.map((ind) => (
            <option key={ind} value={ind}>{ind}</option>
          ))}
          <option value="__add_new__">➕ Add new indicator</option>
        </select>
      ) : (
        <Input
          type="text"
          placeholder="Enter new indicator"
          value={formData.indicator}
          onChange={(e) => handleChange("indicator", e.target.value)}
          onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }}
        />
      )}
    </FieldGroup>


        <FieldGroup>
          <Label>Status</Label>
          <Input
            type="text"
            placeholder="e.g., Ongoing, Completed"
            value={formData.status2024}
            onChange={(e) => handleChange("status2024", e.target.value)}
          />
        </FieldGroup>

        <FieldGroup>
          <Label>Target</Label>
          <Input
            type="text"
            placeholder="e.g., 150 households"
            value={formData.target2025}
            onChange={(e) => handleChange("target2025", e.target.value)}
          />
        </FieldGroup>

        <FieldGroup>
          <Label>Total</Label>
          <Input
            type="text"
            placeholder="e.g., 200"
            value={formData.total}
            onChange={(e) => handleChange("total", e.target.value)}
          />
        </FieldGroup>

        <FieldGroup>
          <Label>Status to Date</Label>
          <Input
            type="text"
            placeholder="e.g., 80% complete"
            value={formData.statusToDate}
            onChange={(e) => handleChange("statusToDate", e.target.value)}
          />
        </FieldGroup>

        <FieldGroup style={{ gridColumn: 'span 2' }}>
          <Label>Remarks</Label>
          <TextArea
            placeholder="Any notes or remarks..."
            value={formData.remarks}
            onChange={(e) => handleChange("remarks", e.target.value)}
          />
        </FieldGroup>

          </CardSection>

          <FormButtonContainer>
              <CancelButton type="button" onClick={onClose}>Cancel</CancelButton>
              <SubmitButton type="submit">Submit</SubmitButton>
            </FormButtonContainer>
        </Form>
      </FormContainer>
    </Container>
  );
}

export default ConvergenceAdd;

// === Styled Components ===

const Container = styled.div`
  padding: 20px;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  background-color: #f2f2f2;
  overflow-y: auto;
`;

const FormContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  overflow-y: auto;
`;

const Title = styled.h2`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 22px;
  margin-bottom: 16px;
  background: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid #ccc;

  span {
    flex: 1;
    text-align: center;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  padding: 5px 10px;

  &:hover {
    color: #cc0000;
  }
`;

const Form = styled.form`
  width: 100%;
`;

// Single-column layout: stack fields vertically with consistent spacing
const CardSection = styled.div`
  background: #fff;
  padding: 10px;
  margin-bottom: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
  color: #333;
`;

const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #4caf50;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;

  &:focus {
    border-color: #388e3c;
    outline: none;
  }
`;

const TextArea = styled.textarea`
  padding: 8px 12px;
  border: 1px solid #4caf50;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  min-height: 60px;

  &:focus {
    border-color: #388e3c;
    outline: none;
  }
`;

const FormButtonContainer = styled.div`
  text-align: right;
  margin-top: 16px;
`;

const CancelButton = styled.button`
  padding: 8px 16px;
  background-color: #ccc;
  border: none;
  border-radius: 4px;
  margin-right: 10px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background-color: #bbb;
  }
`;

const SubmitButton = styled.button`
  padding: 8px 16px;
  background-color: #2e7d32;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #1b5e20;
  }
`;
